import { DesktopTimePicker as DesktopTimePickerMui } from "@mui/x-date-pickers";

const DesktopTimePickerCustom = ({
  id,
  label,
  name,
  onChange,
  value,
  disabled,
  sx,
}) => {
  return (
    <DesktopTimePickerMui
      id={id}
      name={name}
      label={label}
      disabled={disabled}
      onChange={onChange}
      value={value}
      sx={sx}
    />
  );
};

export default DesktopTimePickerCustom;
